<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <!-- <img src="@/assets/img/logo_white.png" alt="logo图"> -->
    </div>
    <p class="title">台州温岭小街软件科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：浙江省台州市温岭市海普佳苑8幢1单元2803室</span>
      <span>Tel：155-5863-8061</span>
    </p>
    <p class="email_wx">
      <span>邮箱：15558638061@163.com</span>
      <span>公司微信号：15558638061</span>
    </p>
    <p style="height: 50px;">
     &nbsp;
    </p>
    <div style="position: fixed; bottom: 0;left: 0; width: 100%;background-color: #000;height: 50px; line-height: 50px;">
      <span class="copy">Copyright &copy; 2018 - 2023 台州温岭小街软件科技有限公司  <span style="margin-left: 50px;"><a href="https://beian.miit.gov.cn/">	浙ICP备2023015851号-1</a></span>
      <span style="margin-left:50px"> <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602004088" style="display:inline-block;text-decoration:none;height:17px;line-height:20px;">
          <img src="../assets/img/icon.png" style="float:left;"/>
          <p style="float:left;height:20px;line-height:20px;margin: 0 0 0 5px;color:#939393;">浙公网安备 33108102001090号</p>
        </a></span>
      </span>
<!--      <div style="width:300px;margin:0 auto; padding:20px 0;">-->

<!--      </div>-->
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue